module.exports = __webpack_public_path__ + "3f07752287b9c2e8ba7273975bcb770d.jpg";